import React, { useState } from "react";
import { Stack } from "@mui/material";
import { HubButton } from "../../components";

import CreateEmployeeSteps from "./CreateEmployeeSteps";
import CreateEmployeeHire from "./CreateEmployeeHire";
import CreateEmployeePersonal from "./CreateEmployeePersonal";
import { useDialogContext } from "../HubDialogWrapper";
import { StyledBox } from "./styles";
import CreateEmployeeAccount from "./CreateEmployeeAccount";

const sx = { minWidth: "120px", padding: "5px" };
const CreateEmployeeFormSteps = ({ isLoading }) => {
  const [step, setStep] = useState(0);
  const { onClose = () => {} } = useDialogContext();

  const handleNext = (e) => {
    e.stopPropagation();
    e.preventDefault();
    return setStep((prev) => Math.min(prev + 1, 2));
  };
  const handleBack = () => setStep((prev) => Math.max(prev - 1, 0));

  return (
    <Stack gap="25px" width="100%" position="relative">
      <CreateEmployeeSteps value={step} />
      <Stack width="100%" position="relative" height="255px" overflow="hidden">
        <StyledBox active={step === 0} m={-1}>
          <CreateEmployeeHire /> {/* Part One */}
        </StyledBox>
        <StyledBox active={step === 1} m={step === 2 ? -1 : 1}>
          <CreateEmployeePersonal /> {/* Part Two */}
        </StyledBox>
        <StyledBox active={step === 2} m={1}>
          <CreateEmployeeAccount /> {/* Part Two */}
        </StyledBox>
      </Stack>
      <Stack direction="row" justifyContent="center" gap="10px">
        <HubButton
          variant="contained"
          color="grey"
          label={step != 0 ? "Back" : "Cancel"}
          size="small"
          onClick={step != 0 ? handleBack : onClose}
          sx={sx}
          disabled={isLoading}
        />
        <HubButton
          label={step != 2 ? "Next" : "Create Employee"}
          {...(step != 2 ? { onClick: handleNext } : { type: "submit" })}
          variant="contained"
          size="small"
          sx={sx}
          disabled={isLoading}
        />
      </Stack>
    </Stack>
  );
};

export default CreateEmployeeFormSteps;
